<ng-container
  *ngIf="{
    product: product$ | async,
    component: component$ | async,
    displayComponent: displayComponent$ | async,
    isLogged: isLogged$ | async,
  } as content"
>
  <div *ngIf="content.displayComponent" class="conteiner-product-intro {{ content.component?.styleClasses }}">
			<h1>{{ content.product?.completeName }}</h1>

    <div class="box-content m-t-20">
      <p *ngIf="content.product?.customerPartNumber">
        <strong>{{ 'intro.customer' | cxTranslate }}#: </strong><span>{{ content.product?.customerPartNumber }}</span>
      </p>

      <p *ngIf="content.product?.partNumber">
        <strong>{{ 'intro.part' | cxTranslate }}#: </strong><span>{{ content.product?.partNumber }}</span>
      </p>

      <p *ngIf="content.product?.catalogNumber">
        <strong>{{ 'intro.catalog' | cxTranslate }}#: </strong><span>{{ content.product?.catalogNumber }}</span>
      </p>

      <p *ngIf="content.product?.modelNumber">
        <strong>{{ 'intro.model' | cxTranslate }}#: </strong><span>{{ content.product?.modelNumber }}</span>
      </p>

      <p *ngIf="content.product?.packagingWeight" class="cel-weight">
        <strong>{{ 'intro.weight' | cxTranslate }}: </strong
        ><span>{{ content.product?.packagingWeight }} {{ content.product?.packagingWeightUom }}</span>
      </p>
    </div>
  </div>
</ng-container>
